module.exports = __webpack_public_path__ + "img/Edit.1ae6ff6e.svg";